import { useEffect, useState } from 'react'
import { MdExpandLess, MdExpandMore } from 'react-icons/md'
import { Button, Card, CardBody, Col, Collapse, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Row, UncontrolledButtonDropdown } from 'reactstrap'
import { Select, toast, Bounce, moment } from '../../../../Components'
import { PracaGetByFilter } from '../../../../Service/ApiService'
import { IoMdRefresh } from 'react-icons/io'
import { Header, Periodo } from './styles'

// Datas do filtro em horário local (Brasília), no formato do input datetime-local.
// Não usar toISOString(): ele converte para UTC e desloca o período em 3h.
const FORMATO = 'YYYY-MM-DDTHH:mm'

const OPCOES = {
  last24Hours: 'Últimas 24 horas',
  today: 'Hoje',
  last7Days: 'Últimos 7 dias',
  last30Days: 'Últimos 30 dias',
  currentMonth: 'Mês atual',
  previousMonth: 'Mês anterior',
  last12Months: 'Últimos 12 meses',
  currentYear: 'Ano atual',
}

function calcularPeriodo(type) {
  const agora = moment()
  const hoje = moment().startOf('day')
  const fimHoje = moment().endOf('day')

  const periodos = {
    last24Hours: [agora.clone().subtract(24, 'hours'), agora],
    today: [hoje, fimHoje],
    last7Days: [hoje.clone().subtract(6, 'days'), fimHoje],
    last30Days: [hoje.clone().subtract(29, 'days'), fimHoje],
    currentMonth: [hoje.clone().startOf('month'), fimHoje],
    previousMonth: [hoje.clone().subtract(1, 'month').startOf('month'), hoje.clone().subtract(1, 'month').endOf('month')],
    last12Months: [hoje.clone().subtract(12, 'months').add(1, 'day'), fimHoje],
    currentYear: [hoje.clone().startOf('year'), fimHoje],
  }
  const [inicio, termino] = periodos[type]
  return { dtInicio: inicio.format(FORMATO), dtTermino: termino.format(FORMATO) }
}

export default function CardFilter({ change }) {
  const [isOpenFilter, setIsOpenFilter] = useState(false)
  const [pracas, setPracas] = useState([])
  const [values, setValues] = useState()

  async function loadPraca() {
    const response = await PracaGetByFilter({ situacao: 'Ativo' })
    if (response) {
      setPracas(response.map((praca) => ({ label: praca.nome, value: praca.pracaId })))
    } else {
      toast('Ops, ocorreu um problema ao carregar as praças', { type: 'warning', transition: Bounce, closeButton: true, autoClose: 5000, position: 'top-right' })
    }
  }

  useEffect(() => {
    const filters = { pracas: [], selectedFilter: 'last7Days', ...calcularPeriodo('last7Days') }

    setValues(filters)
    onBuscar(filters)
    loadPraca()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function onChange(ev) {
    const { name, value } = ev.target
    setValues({ ...values, [name]: value, selectedFilter: 'custom' })
  }
  function onChangeCat(newValue, actionMeta) {
    const { name } = actionMeta
    setValues({ ...values, [name]: newValue })
  }

  function filtroPeriodo(type) {
    const newValues = { ...values, ...calcularPeriodo(type), selectedFilter: type }

    setValues(newValues)
    onBuscar(newValues)
  }

  function onBuscar(filters) {
    if (filters.dtInicio && filters.dtTermino && filters.dtInicio > filters.dtTermino) {
      toast('A data de início deve ser anterior à data de término', { type: 'warning', transition: Bounce, closeButton: true, autoClose: 5000, position: 'top-right' })
      return
    }

    change({
      dtInicio: filters.dtInicio || null,
      dtTermino: filters.dtTermino || null,
      pracaIds: filters.pracas?.map((d) => d.value) || [],
    })
    setIsOpenFilter(false)
  }

  function descreverPeriodo() {
    const formato = values.selectedFilter === 'last24Hours' || values.selectedFilter === 'custom' ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'
    const inicio = values.dtInicio ? moment(values.dtInicio, FORMATO).format(formato) : '...'
    const termino = values.dtTermino ? moment(values.dtTermino, FORMATO).format(formato) : '...'
    const qtdPracas = values.pracas?.length || 0
    return `${inicio} a ${termino} · ${qtdPracas === 0 ? 'todas as praças' : qtdPracas === 1 ? values.pracas[0].label : `${qtdPracas} praças`}`
  }

  return (
    <Card className="main-card mb-3">
      {values && (
        <>
          <Header>
            <Periodo>
              <span>Período</span>
              <strong>{descreverPeriodo()}</strong>
            </Periodo>
            <div>
              <UncontrolledButtonDropdown className="mr-1">
                <DropdownToggle caret color="info">
                  {OPCOES[values.selectedFilter] || 'Personalizado'}
                </DropdownToggle>
                <DropdownMenu>
                  {Object.entries(OPCOES).map(([type, label]) => (
                    <DropdownItem key={type} active={values.selectedFilter === type} onClick={() => filtroPeriodo(type)}>
                      {label}
                    </DropdownItem>
                  ))}
                  <DropdownItem divider />
                  <DropdownItem onClick={() => setIsOpenFilter(true)}>Personalizado...</DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
              <Button onClick={() => onBuscar(values)} className="btn-pill" color="primary">
                <IoMdRefresh size={18} />
                <span className="ml-1">Buscar</span>
              </Button>
              <Button onClick={() => setIsOpenFilter(!isOpenFilter)} className="ml-1 btn-pill" color="outline-primary" id="btCollapse" title="Mais filtros">
                {isOpenFilter ? <MdExpandLess size={18} /> : <MdExpandMore size={18} />}
              </Button>
            </div>
          </Header>
          <Collapse isOpen={isOpenFilter}>
            <CardBody>
              <Row>
                <Col lg={3} md={6}>
                  <FormGroup>
                    <Label>Data início</Label>
                    <Input type="datetime-local" onChange={onChange} value={values.dtInicio} name="dtInicio" id="dtInicio" />
                  </FormGroup>
                </Col>
                <Col lg={3} md={6}>
                  <FormGroup>
                    <Label>Data término</Label>
                    <Input type="datetime-local" onChange={onChange} value={values.dtTermino} name="dtTermino" id="dtTermino" />
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup>
                    <Label>Praça</Label>
                    <Select
                      placeholder="Todas as praças"
                      noOptionsMessage={() => 'Nenhuma opção disponível'}
                      onChange={onChangeCat}
                      value={values.pracas}
                      isClearable
                      name="pracas"
                      className="basic-select"
                      classNamePrefix="select"
                      options={pracas}
                      isMulti
                      closeMenuOnSelect={false}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </CardBody>
          </Collapse>
        </>
      )}
    </Card>
  )
}
